import { configureStore } from "@reduxjs/toolkit";
import thunk from "redux-thunk";
import logger from 'redux-logger'
import rootReducer from "./combineReducer";

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production', 
    applyMiddleware: ([thunk, logger])
})